import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalThemeSpaceHomeOverride: ExperimentalQueries['experimentalThemeSpaceHomeOverride'] =
	(_, { themeAddonKey, themeModuleKey, spaceKey, spaceHomePageId }, { network }) => {
		if (!themeAddonKey || !themeModuleKey) {
			return {
				hasSpaceHomeOverride: false,
				spaceHomeOverrideDescriptor: null,
			};
		}

		const url = `/wiki/plugins/servlet/ac/${themeAddonKey}/${themeModuleKey}/?classifier=json&space.key=${spaceKey}&content.id=${spaceHomePageId}&content.type=page`;

		return fetchJSON(network, url, {
			method: 'GET',
			headers: {
				'Content-Type': MediaType.JSON,
			},
		}).then(
			(data) => ({
				hasSpaceHomeOverride: true,
				spaceHomeOverrideDescriptor: data,
			}),
			() => ({
				hasSpaceHomeOverride: false,
				spaceHomeOverrideDescriptor: null,
			}),
		);
	};
